import { NgModule } from '@angular/core';
import { ExtraOptions, RouterModule, Routes } from '@angular/router';
import { AppLayoutComponent } from './layout/app.layout.component';
import { AuthGuard } from './guard/auth.guard';

const routerOptions: ExtraOptions = {
    anchorScrolling: 'enabled',
    useHash: false
};

const routes: Routes = [
    {
        path: 'auth',
        loadChildren: () => import('./features/auth/auth.module').then(m => m.AuthModule)
    },
    {
        path: '', redirectTo: 'auth/login', pathMatch: 'full'
    },
    {
        path: '', component: AppLayoutComponent,
        children: [
            { path: 'admin', canActivate: [AuthGuard], loadChildren: () => import('./features/dashboards/dashboards.module').then(m => m.DashboardsModule) },
            { path: 'empleados', canActivate: [AuthGuard], loadChildren: () => import('./features/dashboards/employee/employee.module').then(m => m.EmployeeModule) },
            { path: 'casos', canActivate: [AuthGuard], data: { breadcrumb: 'Casos' }, loadChildren: () => import('./features/casos/casos.module').then(m => m.CasosModule) },
            { path: 'profile', canActivate: [AuthGuard], data: { breadcrumb: 'User Management' }, loadChildren: () => import('./features/perfil/profile.module').then(m => m.ProfileModule) },
            { path: 'apps', canActivate: [AuthGuard], data: { breadcrumb: 'Herramientas' }, loadChildren: () => import('./features/herramientas/herramientas.module').then(m => m.HerramientasModule) },
            { path: 'pasarela', canActivate: [AuthGuard], data: { breadcrumb: 'Pasarela de Pagos' }, loadChildren: () => import('./features/pasarela/pasarela.module').then(m => m.PasarelaModule) },
            { path: 'ia/prompts', canActivate: [AuthGuard], data: { breadcrumb: 'Prompt de documentos' }, loadComponent: () => import('./features/ia/prompt-documentos/prompt-documentos.component').then(c => c.PromptDocumentosComponent) },
            { path: 'cupones', canActivate: [AuthGuard], data: { breadcrumb: 'Cupones' }, loadComponent: () => import('./features/cupones/cupones.component').then(c => c.CuponesComponent) },
            { path: 'servicios', canActivate: [AuthGuard], data: { breadcrumb: 'Tipos de asesoría' }, loadComponent: () => import('./features/servicios/servicios.component').then(c => c.ServiciosComponent) },
            { path: 'agendamiento/horario', canActivate: [AuthGuard], data: { breadcrumb: 'Horario de atención' }, loadComponent: () => import('./features/agendamiento-horario/agendamiento-horario.component').then(c => c.AgendamientoHorarioComponent) }
        ]
    },
    { path: 'notfound', loadChildren: () => import('./demo/components/notfound/notfound.module').then(m => m.NotfoundModule) },
    { path: '**', redirectTo: '/notfound' }
];

@NgModule({
    imports: [RouterModule.forRoot(routes, routerOptions)],
    exports: [RouterModule]
})
export class AppRoutingModule { }
